/* eslint-disable import/prefer-default-export */
import COLORS from '~/constants/colors';

export const THRESHOLD_COLORS = {
  perfect: COLORS.gold,
  good: COLORS.wildWillow,
  okay: COLORS.swampGreen,
  bad: COLORS.gothic,
  awful: COLORS.horizon,
  pre: COLORS.white,
  miss: COLORS.doveGray,
};
